import { useEffect, useState } from 'react';

/**
 * **Der Abspielkopf am Desktop zum Ziehen** (7.206; Sascha, 4. Oktober:
 * „Mobil sollte er ja in der Mitte bleiben“). Mit Maus und breitem Fenster
 * steht die Zeitleiste still, und der Kopf wandert über sie; am Telefon
 * bleibt die Linie in der Mitte, und der Schnitt läuft darunter durch.
 *
 * `?kopf=fest` oder `?kopf=frei` in der Adresse entscheidet von Hand -- für
 * Prüfungen, und für wen das andere lieber hat.
 */
const ANFRAGE = '(pointer: fine) and (min-width: 900px)';

function gewaehlt(): boolean {
  if (typeof window === 'undefined') return false;
  const adresse = new URLSearchParams(window.location.search).get('kopf');
  if (adresse === 'frei') return true;
  if (adresse === 'fest') return false;
  return window.matchMedia?.(ANFRAGE).matches ?? false;
}

export function useFreierKopf(): boolean {
  const [frei, setFrei] = useState(gewaehlt);
  useEffect(() => {
    const m = window.matchMedia?.(ANFRAGE);
    if (!m) return;
    const neu = () => setFrei(gewaehlt());
    m.addEventListener('change', neu);
    return () => m.removeEventListener('change', neu);
  }, []);
  return frei;
}
